function generateYears(from) {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = from; i <= currentYear; i++) {
    years.push({ label: i, value: i });
  }
  return years;
}

export const years = generateYears(2020);

export const months = [
  { label: 'Január', value: '01' },
  { label: 'Február', value: '02' },
  { label: 'Március', value: '03' },
  { label: 'Április', value: '04' },
  { label: 'Május', value: '05' },
  { label: 'Június', value: '06' },
  { label: 'Július', value: '07' },
  { label: 'Augusztus', value: '08' },
  { label: 'Szeptember', value: '09' },
  { label: 'Október', value: '10' },
  { label: 'November', value: '11' },
  { label: 'December', value: '12' },
];

export const headers = [
  { text: 'Nap', value: 'index', align: 'start', sortable: false },
  { text: 'Érkezés', value: 'first_enter', sortable: false },
  { text: 'Távozás', value: 'last_leave', sortable: false },
  { text: 'Bent töltött percek száma', value: 'spent_min', sortable: false },
  { text: 'Bent töltött órák száma', value: 'spent_hour', sortable: false },
  { text: 'Mozgások', value: 'events', sortable: false },
];
